export default __webpack_public_path__ + "static/media/Suites-RGB-portrait.2432810e.webp";